export enum ExportType {
    Pdf = 1,
    Excel = 2
}
